// Form validation for New Milestone form
import {
  plaintextValidator,
  dropdownValidator,
  multiselectValidator,
  numberValidator
} from '../fields';
import { stringMandateConstraints } from '../utils';

const config = { mandatory: true };

const executionObj = {
  ONCE: {
    EMPTY: {}
  },
  SCHEDULED: {
    EVERY_MINUTE: {
      'scheduleDetail.interval': numberValidator({
        ...config,
        customError: '^Enter interval',
        optional: {
          greaterThanOrEqualTo: 30,
          notGreaterThanOrEqualTo:
            '^Minimum time interval should be 30 mins or above'
        }
      }),
      'scheduleDetail.scheduleType': dropdownValidator({
        ...config,
        customError: 'Select schedule type'
      })
    },
    HOURLY: {
      'scheduleDetail.interval': plaintextValidator({
        ...config,
        customError: '^Enter interval'
      }),
      'scheduleDetail.scheduleType': dropdownValidator({
        ...config,
        customError: 'Select schedule type'
      })
    },
    DAILY: {
      'scheduleDetail.time': plaintextValidator({
        ...config,
        customError: '^Select time'
      }),
      'scheduleDetail.scheduleType': dropdownValidator({
        ...config,
        customError: 'Select schedule type'
      })
    },
    WEEKLY: {
      'scheduleDetail.time': plaintextValidator({
        ...config,
        customError: '^Select time'
      }),
      'scheduleDetail.dayOfWeek': multiselectValidator({
        ...config,
        customError: 'Day should be selected'
      }),
      'scheduleDetail.scheduleType': dropdownValidator({
        ...config,
        customError: 'Select schedule type'
      })
    },
    MONTHLY: {
      'scheduleDetail.time': plaintextValidator({
        ...config,
        customError: '^Select time'
      }),
      'scheduleDetail.dayOfMonth': dropdownValidator({
        ...config,
        customError: 'Select day of month'
      }),
      'scheduleDetail.scheduleType': dropdownValidator({
        ...config,
        customError: 'Select schedule type'
      })
    },
    FORTNIGHTLY: {
      'scheduleDetail.time': plaintextValidator({
        ...config,
        customError: '^Select time'
      }),
      'scheduleDetail.dayOfWeek': multiselectValidator({
        ...config,
        customError: 'Day should be selected'
      }),
      'scheduleDetail.scheduleType': dropdownValidator({
        ...config,
        customError: 'Select schedule type'
      })
    },
    MONTHLY_WEEK: {
      'scheduleDetail.time': plaintextValidator({
        ...config,
        customError: '^Select time'
      }),
      'scheduleDetail.dayOfWeek': multiselectValidator({
        ...config,
        customError: 'Day should be selected'
      }),
      'scheduleDetail.alignedWeekOfMonth': dropdownValidator({
        ...config,
        customError: 'Select Week of Month'
      }),
      'scheduleDetail.scheduleType': dropdownValidator({
        ...config,
        customError: 'Select schedule type'
      })
    },
    EMPTY: {
      'scheduleDetail.scheduleType': dropdownValidator({
        ...config,
        customError: 'Select schedule type'
      })
    }
  }
};

export default ({ executionType, scheduleType, noNameValidate }) => ({
  name: noNameValidate ? true : plaintextValidator(config),
  script: dropdownValidator(config),
  scriptArguments: {
    array: {
      value: stringMandateConstraints
    }
  },
  ...executionObj[executionType]?.[scheduleType || 'EMPTY']
});
